export const RTL_REGEX = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/;
export const LTR_REGEX = /\p{L}/u;

// NOTE: NSAI-6726 — the Unicode blocks allocated to right-to-left scripts,
// supplementary planes included (Adlam, Mende Kikakui, the old Semitic and
// Iranian scripts). Only meaningful on a character already known to be a
// letter: the same blocks hold digits and punctuation (`١٢٣`, `،`) that the
// bidi algorithm treats as weak or neutral, so matching them alone is not
// "strong RTL". Pairing it with `LTR_REGEX` (`\p{L}`) is what `RTL_REGEX`
// above cannot do without changing every caller of `direction()`.
export const RTL_BLOCK_REGEX =
  /[\u0590-\u08FF\uFB1D-\uFDFF\uFE70-\uFEFF\u{10800}-\u{10FFF}\u{1E800}-\u{1EFFF}]/u;

// NOTE: NSAI-6726 — ARABIC LETTER MARK: a zero-width strong right-to-left
// character, like RLM, that the bidi algorithm reads as Arabic.
export const ARABIC_LETTER_MARK = "\u061C";

// NOTE: NSAI-4800 — Unicode bidi isolates (UAX #9). FSI opens a run whose
// direction is resolved from its own first strong character; PDI closes it. Both
// are zero-width and non-printing, so they change how a line is laid out without
// adding a visible glyph. They do count toward `String.length`, so isolate text
// on its way to the screen — never a value that is about to be compared,
// searched, persisted or sent over the wire.
export const FIRST_STRONG_ISOLATE = "\u2068";
export const POP_DIRECTIONAL_ISOLATE = "\u2069";

// NOTE: NSAI-5958 — the two bidi MARKS (UAX #9), as opposed to the isolates
// above. LRM/RLM are zero-width, non-printing STRONG characters: a
// first-strong resolver (the Unicode bidi algorithm, Android's
// `TextDirectionHeuristics.FIRSTSTRONG_LTR`, `direction()` here) reads them as
// a letter of that direction. Prepending one to text that has no strong
// character of its own gives it a base direction on every platform at once,
// without naming a physical side. Same caveat as the isolates: they count
// toward `String.length`, so they belong on text on its way to the screen only.
export const LEFT_TO_RIGHT_MARK = "\u200E";
export const RIGHT_TO_LEFT_MARK = "\u200F";
